import { logsList_template as VendorLogsList_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/logsList_template";
import { renderKoDataTable, renderKoEmptyState, renderKoTextCell } from "~/components/templates/listPageDataTable";
import { listPageSelect_template } from "~/components/templates/listPageSelect_template";
import { html, LpButton, LpFilterBar, LpPageHeader, LpTable, raw } from "~/design-system";
export class logsList_template extends VendorLogsList_template {
    getTemplateHtml() {
        return /* html */ `
            ${LpPageHeader({
            title: "Logs",
            description: "Review system activity and execution history.",
            icon: "list-magnifying-glass",
            controls: LpFilterBar({
                controls: html `
                        <div class="list-page-filter-cell">
                            ${raw(this.accountFilter.getHtmlBuild())}
                        </div>
                        <div class="list-page-filter-cell">
                            ${raw(this.operationFilter.getHtmlBuild())}
                        </div>
                    `,
            }),
        })}

            <div class="list-page-module">
                <div class="data-module__body list-page-module__body" id="list-results">
                    ${this.getLogsTableHtml()}
                </div>
                <div class="data-module__footer list-page-module__footer">
                    <div class="list-page-module__toolbar">
                        <div class="list-page-module__meta">
                            ${this.resultsInfo.getHtmlBuild()}
                        </div>
                        <div class="list-page-module__pagination">
                            ${this.pagination.getHtmlBuild()}
                        </div>
                    </div>
                </div>
            </div>
        `;
    }
    getLogsTableHtml() {
        const columns = this.getLogTableColumns();
        return renderKoDataTable({
            title: "Logs",
            titleIcon: "list-magnifying-glass",
            caption: "System logs",
            columns,
            actions: html `<div class="list-page-module__search">${raw(this.keywordSearch.getHtmlBuild())}</div>`,
            className: "logs-table",
            children: this.getLogsTableBodyHtml(columns),
        });
    }
    getLogTableColumns() {
        return [
            {
                key: "id",
                label: "Id",
                sortable: true,
                resizable: true,
                width: 96,
                minWidth: 80,
                sortAttributes: this.getSortAttributes("id", "highlight"),
            },
            {
                key: "dateLog",
                label: "Date Log",
                sortable: true,
                resizable: true,
                width: 220,
                minWidth: 180,
                sortAttributes: this.getSortAttributes("dateLog"),
            },
            {
                key: "message",
                label: "Message",
                sortable: true,
                resizable: true,
                minWidth: 280,
                sortAttributes: this.getSortAttributes("message"),
            },
            {
                key: "type",
                label: "Account",
                sortable: true,
                resizable: true,
                width: 180,
                minWidth: 140,
                sortAttributes: this.getSortAttributes("type"),
            },
            {
                key: "fullList",
                label: "See in Full List",
                align: "end",
                width: 132,
                minWidth: 112,
                required: true,
            },
        ];
    }
    getSortAttributes(column, trackedClass) {
        const args = trackedClass ? `'${column}', '${trackedClass}'` : `'${column}'`;
        return {
            "data-bind": `click: onClickReorder.bind($data, ${args}), css: { 'is-desc': orderByAndDirection()=='${column}_DESC', 'is-asc': orderByAndDirection()=='${column}_ASC' }`,
        };
    }
    getLogsTableBodyHtml(columns) {
        return html `
            <input data-bind="value: orderBy" type="hidden">
            <input data-bind="value: orderByDirection" type="hidden">
            ${LpTable.Body({
            attributes: {
                "data-bind": "foreach: logs",
            },
            children: LpTable.Row({
                attributes: {
                    "data-bind": "attr: { id: 'row-' + $data.id }, css: { highlight: $data.highlight }",
                },
                children: html `
                        ${this.getLogTextCell(columns[0], "id", "log_id")}
                        ${this.getLogTextCell(columns[1], "dateLog && dateLog.date", "log_dateLog")}
                        ${LpTable.Cell({
                    column: columns[2],
                    className: "log_message",
                    children: html `<span class="lp-table_cell-content" data-bind="html: message"></span>`,
                })}
                        ${this.getLogTextCell(columns[3], "type", "log_type")}
                        ${LpTable.Cell({
                    column: columns[4],
                    className: "list-page-table__actions",
                    children: LpButton({
                        ariaLabel: "See in Full List",
                        prefixIcon: "arrow-left",
                        size: "sm",
                        shape: "square",
                        variant: "secondary",
                        attributes: {
                            "data-bind": "click: $parent.onClickLogTrack",
                        },
                    }),
                })}
                    `,
            }),
        })}
            ${renderKoEmptyState({
            colSpan: columns.length,
            visibleBinding: "logs().length === 0",
            title: "No logs found",
            description: "No logs match the current filters.",
            icon: "list-magnifying-glass",
        })}
        `;
    }
    getLogTextCell(column, binding, className) {
        return renderKoTextCell({
            column,
            binding,
            className,
        });
    }
    initPartial() {
        super.initPartial();
        const vm = this.getTemplateViewModel();
        this.accountFilter = new listPageSelect_template("accountFilter", vm, this.caller);
        this.accountFilter.setLabel("Task executers");
        this.accountFilter.setShowLabelPrefix(true);
        this.accountFilter.setOptions([{ id: "0", name: "all" }]);
        this.accountFilter.setSelectedOption("0");
        this.operationFilter = new listPageSelect_template("operationFilter", vm, this.caller);
        this.operationFilter.setLabel("Operations");
        this.operationFilter.setShowLabelPrefix(true);
        this.operationFilter.setOptions([{ id: "0", name: "all" }]);
        this.operationFilter.setSelectedOption("0");
        this.keywordSearch.setPlaceholder("Search");
    }
    setAccountFilterItems(accounts) {
        const options = [{ id: "0", name: "all" }, ...(accounts || [])];
        this.accountFilter.setOptions(options);
    }
    setOperationFilterItems(operations) {
        const options = [{ id: "0", name: "all" }, ...(operations || [])];
        this.operationFilter.setOptions(options);
    }
    resetSelectedAccountFilter() {
        this.accountFilter.setSelectedOption("0");
    }
    resetSelectedOperationFilter() {
        this.operationFilter.setSelectedOption("0");
    }
    setViewModelFromRequest(params) {
        if (!params) {
            return;
        }
        const vm = this.getTemplateViewModel();
        if (typeof params.orderBy !== "undefined" && typeof vm.orderBy === "function") {
            vm.orderBy(params.orderBy);
        }
        if (typeof params.orderByDirection !== "undefined" && typeof vm.orderByDirection === "function") {
            const direction = String(params.orderByDirection).toUpperCase() === "ASC" ? "ASC" : "DESC";
            vm.orderByDirection(direction);
            if (typeof vm.orderByAndDirection === "function" && typeof vm.orderBy === "function") {
                vm.orderByAndDirection(vm.orderBy() + "_" + direction);
            }
        }
        if (typeof params.pagination !== "undefined" && this.pagination?.getTemplateViewModel?.()?.pageNumber) {
            this.pagination.getTemplateViewModel().pageNumber(Math.max(1, Number(params.pagination) || 1));
        }
        if (typeof params.keyword !== "undefined") {
            this.keywordSearch.getTemplateViewModel().filterKeyword(params.keyword || "");
            this.keywordSearch.getTemplateViewModel().filterInputClearButton(params.keyword ? 1 : 0);
        }
        if (typeof params.accountFilter !== "undefined") {
            this.accountFilter.setSelectedOption(params.accountFilter || "0");
        }
        if (typeof params.operationFilter !== "undefined") {
            this.operationFilter.setSelectedOption(params.operationFilter || "0");
        }
    }
    getMainElementClasses() {
        return ["w-content"];
    }
}
